import {Completable, completed, EmployerSummaryDTO, pending, pristine} from 'kashable-mobile-common';

import {fetchEmployer as fetchEmployerRequest} from '../apis/employer';
import {RootState} from '../store';

import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<EmployerSummaryDTO> = pristine();

export const fetchEmployer = createAsyncThunk('employer/fetch', async (employer, {rejectWithValue}) => {
    const response = await fetchEmployerRequest();

    if (response.error) {
        rejectWithValue(response);
    }

    return response;
});

export const employerSlice = createSlice({
    name: 'employer',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearEmployer: () => {
            return {...INITIAL_STATE};
        },
        update(state, action: PayloadAction<Partial<EmployerSummaryDTO>>) {
            if (state.value) {
                return completed({ ...state.value, ...action.payload });
            }
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployer.pending, () => {
                return pending();
            })
            .addCase(fetchEmployer.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const {
    clearEmployer,
    update,
} = employerSlice.actions;

export const selectEmployer = (state: RootState) => state.employer;
export default employerSlice.reducer;
